/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcription_MinutesInputs */

const en_transcription_minutes = /** @type {(inputs: Transcription_MinutesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transcription Minutes`)
};

const fr_transcription_minutes = /** @type {(inputs: Transcription_MinutesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minutes de transcription`)
};

const de_transcription_minutes = /** @type {(inputs: Transcription_MinutesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protokoll`)
};

const it_transcription_minutes = /** @type {(inputs: Transcription_MinutesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verbali di trascrizione`)
};

const ru_transcription_minutes = /** @type {(inputs: Transcription_MinutesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Транскрипция минут`)
};

const es_transcription_minutes = /** @type {(inputs: Transcription_MinutesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minutos de transcripción`)
};

const zh_cn2_transcription_minutes = /** @type {(inputs: Transcription_MinutesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`转录会议记录`)
};

const ja_transcription_minutes = /** @type {(inputs: Transcription_MinutesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`転写議事録`)
};

const hi_transcription_minutes = /** @type {(inputs: Transcription_MinutesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रतिलेखन कार्यवृत्त`)
};

const pt_pt2_transcription_minutes = /** @type {(inputs: Transcription_MinutesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ata de transcrição`)
};

/**
* | output |
* | --- |
* | "Transcription Minutes" |
*
* @param {Transcription_MinutesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcription_minutes = /** @type {((inputs?: Transcription_MinutesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcription_MinutesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_transcription_minutes(inputs)
	if (locale === "de") return de_transcription_minutes(inputs)
	if (locale === "it") return it_transcription_minutes(inputs)
	if (locale === "ru") return ru_transcription_minutes(inputs)
	if (locale === "es") return es_transcription_minutes(inputs)
	if (locale === "zh-CN") return zh_cn2_transcription_minutes(inputs)
	if (locale === "ja") return ja_transcription_minutes(inputs)
	if (locale === "hi") return hi_transcription_minutes(inputs)
	if (locale === "pt-PT") return pt_pt2_transcription_minutes(inputs)
	return en_transcription_minutes(inputs)
});